Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.NoneValuesMapper
  @TYPE = 'none'

  constructor: (identifier) ->
    @identifier = identifier
    @type = CustomerVisualMode.Mappers.NoneValuesMapper.TYPE

  canHandle: (type) ->
    type == @type

  mapToCompositeFilter: (intelligentGroups) ->
    {included: {type: @type}}

  mapToSearchQuery: (intelligentGroups) ->
    included = intelligentGroups.included
    return {} unless included
    {main_groups: [@identifier]}
